module.exports = __webpack_public_path__ + "static/pod-intro-img-1-117e171fad2d07f337a748972fe7ead3.png";